import axios from "axios";
export default axios.create({
     baseURL:'https://form-store-447b9-default-rtdb.firebaseio.com/'
})